var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"break"},[_vm._v(" "+_vm._s(_vm._f("name")(_vm._f("whoIdIs")(_vm.allCharacter,_vm.options.player)))+" は怯んだ！ ")])])}
var staticRenderFns = []

export { render, staticRenderFns }